module.exports = __webpack_public_path__ + "media/127.6495d285.wav";